"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Modals/QueueMessages/GateSummary.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _format = require('web/screens/Broadcast/format');

const NAMES_SHOWN = 3

const recipientName = (r) =>
  [r.FirstName, r.LastName].filter(Boolean).join(' ') || 'Unnamed patient'

/* "Doyle Frances, Nakamura Ken, and 4 more" */
const affected = (recipients, count) => {
  const names = recipients.slice(0, NAMES_SHOWN).map(recipientName).join(', ')
  const rest = count - Math.min(recipients.length, NAMES_SHOWN)
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  names 
      ,  rest > 0 && _react2.default.createElement('span', { className: "broadcast-gate--dim", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  names ? ', and' : '' , " " ,  _format.formatCount.call(void 0, rest) , " more" ) 
    )
  )
}

const Mono = ({ children }) => (
  _react2.default.createElement('code', { className: "broadcast-wizard--mono", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  children )
)

/* Send dialog v2 (D-82): a refusal is one banner whose title is the problem
 * itself, with who it affects and the fix under it; each problem when there
 * is more than one. Then who would get the message, and the dialog's two
 * buttons. */
 const GateRefusal = ({ gate }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement('div', { role: "alert", className: "broadcast-banner broadcast-banner--danger" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
      , _react2.default.createElement('span', { className: "broadcast-banner--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "⛔")
      , _react2.default.createElement('div', { className: "broadcast-gate--problems", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        ,  gate.MissingVariables.map(v => (
          _react2.default.createElement('div', { key: v.Name, className: "broadcast-gate--problem", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
              ,  _format.formatCount.call(void 0, v.Count) , " of "  ,  _format.pluralize.call(void 0, gate.TotalRecipients, 'patient', 'patients') 
              , ' ',  v.Count === 1 ? 'has' : 'have' , " no value for "    , _react2.default.createElement(Mono, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 41}},  v.Name ), " and the message gives no fallback."

            )
            , _react2.default.createElement('div', { className: "broadcast-gate--affected", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
              ,  affected(v.Recipients, v.Count) , ". Add a fallback to "     , _react2.default.createElement(Mono, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}},  v.Name ), ", or remove them, then try again."

            )
          )
        ))
        ,  gate.TooLongCount > 0 && (
          _react2.default.createElement('div', { className: "broadcast-gate--problem", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
              ,  _format.pluralize.call(void 0, gate.TooLongCount, 'patient\'s message is', 'patients\' messages are') 
              , ' ', "over the "  ,  _format.formatCount.call(void 0, gate.Limit) , "-character limit."
            )
            , _react2.default.createElement('div', { className: "broadcast-gate--affected", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
              ,  affected(gate.TooLong, gate.TooLongCount) 
              ,  gate.TooLong[0] && _react2.default.createElement(_react2.default.Fragment, null, " (longest "  ,  _format.formatCount.call(void 0, gate.TooLong[0].Length) , " characters)" ) , "."
              , ' ', "Shorten the message, or remove them, then try again."
            )
          )
        )
      )
    )
    , _react2.default.createElement('p', { className: "broadcast-send--lead broadcast-send--lead-refused" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
      , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}},  _format.pluralize.call(void 0, gate.TotalRecipients, 'patient', 'patients') ), " would get this message."
      , ' ', "Nothing is sent until "    ,  gate.TooLongCount > 0 ? 'it fits' : 'it\'s fixed' , "."
    )
  )
); exports.GateRefusal = GateRefusal

const skippedOf = (gate) =>
  _nullishCoalesce(gate.SkippedRecipients, () => ( Math.max(0, gate.TotalRecipients - gate.ReadyRecipients)))

/* Rev 31 Q6: before sending, who is skipped and why. They stay in the
 * campaign, Not scheduled, so fixing them and sending again reaches them. */
 const SkippedNote = ({ gate }) => {
  const skipped = skippedOf(gate)
  if (!skipped) return null
  const names = gate.MissingVariables.map(v => v.Name)
  // Rev 35 E4: a blank first or last name has no default, only a fallback.
  const builtIns = names.filter(_broadcastTemplate.isBuiltInVariable)
  const shown = names.map(n => _broadcastTemplate.isBuiltInVariable.call(void 0, n) ? _broadcastTemplate.builtInLabel.call(void 0, n) : n).join(' or ')
  const missingReason = !builtIns.length
    ? `they have no ${shown} and ${names.length === 1 ? 'it has' : 'they have'} no default`
    : builtIns.length === names.length
      ? `they have no ${shown} and the message gives ${names.length === 1 ? 'it' : 'them'} no fallback`
      : `they have no ${shown}, with no default or fallback`
  const reasons = [
    names.length > 0 && missingReason,
    (_nullishCoalesce(gate.NoContactCount, () => ( 0))) > 0 && `${_format.pluralize.call(void 0, _nullishCoalesce(gate.NoContactCount, () => ( 0)), 'has', 'have')} no valid phone or email`,
  ].filter(Boolean).join('; ')
  return (
    _react2.default.createElement('div', { role: "note", 'aria-label': "Skipped recipients" , className: "broadcast-banner broadcast-banner--warn broadcast-gate--skipped"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
      , _react2.default.createElement('span', { className: "broadcast-banner--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "⚠")
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
        ,  _format.pluralize.call(void 0, skipped, 'recipient is', 'recipients are') , " skipped" ,  reasons ? `: ${reasons}` : '' , "."
        , ' ', "They stay in the campaign, Not scheduled."
      )
    )
  )
}; exports.SkippedNote = SkippedNote

/* Send dialog v2 (D-82): one line where the facts card was. "300 patients
 * will get this message · 2 skipped · longest 107 of 1,600 characters".
 * Under it, how many are texted the consent request first ("At least" when
 * the server's count stopped early). */
 const GateLead = ({ gate }) => {
  const skipped = skippedOf(gate)
  const askFirst = _nullishCoalesce(gate.AskFirstCount, () => ( 0))
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('p', { className: "broadcast-send--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 114}},  _format.pluralize.call(void 0, gate.ReadyRecipients, 'patient', 'patients') ), " will get this message"
        ,  skipped > 0 && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('span', { className: "broadcast-send--sep", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}, " · "  ),  _format.formatCount.call(void 0, skipped) , " skipped" ) 
        ,  gate.Longest && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('span', { className: "broadcast-send--sep", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}, " · "  )
            , _react2.default.createElement('span', { className: "broadcast-send--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}, "longest "
               ,  _format.formatCount.call(void 0, gate.Longest.Length) , " of "  ,  _format.formatCount.call(void 0, gate.Limit) , " characters"
            )
          )
        )
      )
      ,  askFirst > 0 && (
        _react2.default.createElement('p', { className: "broadcast-send--consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
          ,  gate.AskFirstCapped ? 'At least ' : '' ,  _format.formatCount.call(void 0, askFirst) , " will be asked for consent first."
        )
      )
    )
  )
}; exports.GateLead = GateLead
